import { emailSchema, msg, passwordSchema, usernameSchema } from '~/utils/validation';
import { z } from 'zod';

export const schema = z
  .object({
    password2: passwordSchema,
    password1: passwordSchema,
    first_name: z.string().min(1, { message: msg.required }),
    last_name: z.string().min(1, { message: msg.required }),
    username: usernameSchema,
    email: emailSchema,
  })
  .superRefine(({ password1, password2 }, ctx) => {
    if (password1 !== password2) {
      ctx.addIssue({
        message: msg.passwordConfirm,
        path: ['password2'],
        code: 'custom',
      });
    }
  });

export type Schema = z.infer<typeof schema>;
